import { render, staticRenderFns } from "./UserCustomers.vue?vue&type=template&id=5c70f274&scoped=true&"
import script from "./UserCustomers.vue?vue&type=script&lang=js&"
export * from "./UserCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70f274",
  null
  
)

export default component.exports